<script setup lang="ts">
import { useI18n } from '@/shared/i18n'
import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'

defineEmits<{ export: [] }>()

const { t } = useI18n()
</script>

<template>
  <Button data-pdf-ignore variant="outline" size="sm" @click="$emit('export')">
    <Icon name="download" :size="14" />
    {{ t('insights.elements.exportCsv') }}
  </Button>
</template>
